import moment from 'moment';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import Documents from '../../../../components/Documents';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import TableActions from '../../../../components/TableActions';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetAntrepoOutListPagingAndFilterRequest } from '../../../../models/request/antrepoOut/GetAntrepoOutListPagingAndFilterRequest';
import { GetAntrepoOutListPagingAndFilterResponseItem } from '../../../../models/response/antrepoOut/GetAntrepoOutListPagingAndFilterResponse';
import { GetCompanyListResponseItem } from '../../../../models/response/company/GetCompanyListResponse';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetAntrepoOutListPagingAndFilterRequest
    getData: (_filter?: GetAntrepoOutListPagingAndFilterRequest | undefined) => Promise<void>
    setFilter: React.Dispatch<React.SetStateAction<GetAntrepoOutListPagingAndFilterRequest>>
    items: GetAntrepoOutListPagingAndFilterResponseItem[]
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const AntrepoOutListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    getData,
    setFilter,
    items,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            {
                auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canDocument && (
                    <Documents
                        items={items.map(function (x) {
                            return { entityId: x.antrepoOutId, isSelected: x.isSelected }
                        })}
                        pageName={pageName}
                    />
                )
            }

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            {/* Filtreler paneli ve arama kutusu kaldırıldı (22.09.2026): Antrepo Çıkış Tarihi, Alıcı /
                Gönderici Firma, Araç / Dorse Plaka, Tedarikçi ve Çıkış Türü kolon başlığının altındaki
                filtrede. Aramanın baktığı Konteyner / Taşıma Belge / Kamyon Rapor No gizli kolon olarak
                kolon seçicide. Alıcı Firma artık ekranda görünen çıkış kaydının alıcısına göre süzer
                (eski panel giriş kaydının alıcısına bakıyordu). */}
        </React.Fragment>
    )
}

export default AntrepoOutListFilters;